import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Form, Input, Button, Modal, Spin } from 'antd'
import { sendMobileAppLink } from '../../store/action/patient.action'
import _ from 'lodash'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import util from '../../util/util'
import { constants } from '../../constants'
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
var form = null

const SelfRegistration = (props) => {
  const [open, setOpen] = useState(false)
  const [spin, setSpin] = useState(false)
  const companyAdmin = props.currentUserRole == constants.ROLE.COMPANY_ADMIN
  const [linkform] = Form.useForm()
  const history = useHistory()
  // Readiness of the Patient Quick Start for this clinic, derived server-side
  // from clinic state -- there is no stored ready flag to go stale.
  const [quickStart, setQuickStart] = useState({ ready: true, missing: [] })
  const [missingOpen, setMissingOpen] = useState(false)

  useEffect(() => {
    formClear()
  }, [open])

  // Asked as the dialog opens rather than on click: opening the PDF has to stay
  // a synchronous response to the click or the browser blocks the new tab.
  useEffect(() => {
    if (!open || !props.customer?._id) return
    let cancelled = false
    fetch(`${constants.API_URL}/app/download/${props.customer._id}/readiness`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled) setQuickStart(data)
      })
      // If the check itself fails, fall through to the guide rather than
      // blocking a workflow that worked before this check existed.
      .catch(() => {
        if (!cancelled) setQuickStart({ ready: true, missing: [] })
      })
    return () => {
      cancelled = true
    }
  }, [open, props.customer?._id])

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      var values = _.pickBy(data, _.identity)
      if (values.lastname_plain)
        values.lastname_plain = values.lastname_plain.trim()
    })
  }

  var formClear = () => {
    linkform && linkform.resetFields()
  }

  const sendMobileAppLink = async (values) => {
    await props
      .sendMobileAppLink({
        ...values,
        customerid: companyAdmin ? props.customer?._id : null,
      })
      .then((res) => formClear())
    setSpin(false)
  }

  const handleQrCode = () => {
    if (!props.customer?._id) return
    // Surface only what is actually missing instead of handing a patient a
    // guide with a blank support number on it.
    if (!quickStart.ready && quickStart.missing?.length) {
      setMissingOpen(true)
      return
    }
    const qrCodeUrl = `${constants.API_URL}/app/download/${props.customer._id}`
    window.open(qrCodeUrl, '_blank', 'noopener,noreferrer')
  }

  const renderMissingModal = () => {
    const count = quickStart.missing?.length || 0
    return (
      <Modal
        title={`Patient Quick Start needs ${count} item${count === 1 ? '' : 's'}`}
        centered
        visible={missingOpen}
        onCancel={() => setMissingOpen(false)}
        footer={[
          <Button key='cancel' onClick={() => setMissingOpen(false)}>
            Cancel
          </Button>,
          <Button
            key='update'
            type='primary'
            onClick={() => history.push('/customers/edit/' + props.customer._id)}
          >
            Update
          </Button>,
        ]}
      >
        <ul style={{ paddingLeft: 18, margin: 0 }}>
          {(quickStart.missing || []).map((item) => (
            <li key={item.field}>{item.label}</li>
          ))}
        </ul>
      </Modal>
    )
  }

  const renderSendLinkForm = () => {
    return (
      <Spin spinning={spin}>
        <div className='sendLinkForm'>
          <Form
            form={linkform}
            onFinish={(values) => {
              setSpin(true)
              sendMobileAppLink(values)
            }}
            labelCol={{ span: 10 }}
            wrapperCol={{ span: 14 }}
          >
            <Form.Item
              label='Patient Cell Phone'
              name='phone'
              rules={[
                () => ({
                  validator(rule, value) {
                    const parsedNumber = value
                      ? parsePhoneNumber(value, 'US')
                      : null
                    if (
                      parsedNumber &&
                      parsedNumber.country === 'US' &&
                      isValidPhoneNumber(value)
                    ) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error('Please enter a valid U.S. phone number.')
                    )
                  },
                }),
              ]}
            >
              <PhoneInput
                addInternationalOption={false}
                initialValueFormat='national'
                defaultCountry='US'
                className='phone-input fullWidth'
                enableAreaCodes
                countries={['US']}
                international={false}
              />
            </Form.Item>

            <Form.Item
              label='Patient Email(optional)'
              name='email'
              rules={[
                {
                  required: false,
                  whitespace: true,
                  message: 'Please enter valid email',
                  type: 'email',
                },
              ]}
            >
              <Input maxLength={200} />
            </Form.Item>

            <Row justify='end'>
              <Col offset={8}>
                <Button type='primary' htmlType='submit'>
                  Send Link
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Spin>
    )
  }

  return (
    <>
      <Row align={'end'}>
        <Col>
          <Row justify={'end'}>
            <Button
              id={'patientselfregister'}
              className={'actionBtn'}
              onClick={() => {
                setOpen(true)
              }}
              style={{ width: 'fit-content' }}
            >
              PATIENT SELF REGISTER
            </Button>
          </Row>
        </Col>
      </Row>
      <Modal
        title='Send link and registration instructions to patient'
        centered
        className={'filterModal'}
        visible={open}
        closable={true}
        maskClosable={false}
        keyboard={false}
        width={'30%'}
        okText={'Create Patient'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
        footer={[
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button
              style={{
                backgroundColor: '#001529',
                color: 'white',
                width: 'fit-content',
              }}
              className={'actionBtn'}
              onClick={handleQrCode}
            >
              View QR Code & Instructions
            </Button>
            <Button
              key='cancel'
              onClick={() => setOpen(false)}
              style={{ marginLeft: '10px' }}
            >
              Close
            </Button>
          </div>,
        ]}
      >
        {renderSendLinkForm()}
      </Modal>
      {renderMissingModal()}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    currentUserRole: state.profile?.user?.role,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    sendMobileAppLink: (params) => dispatch(sendMobileAppLink(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelfRegistration)
